/*
This Context is owned by the Rep Messaging Team (hs-comm-rep-messaging-fe - https://hubspot.enterprise.slack.com/archives/C03SX61R6QH)
*/
import { createContext } from 'react';
export const NULL_STATE = {
  shouldShowAIOnboardingPopover: false,
  setHasSeenAIOnboardingPopover: () => {}
};
const onboardingContext = /*#__PURE__*/createContext(NULL_STATE);
export default onboardingContext;